import 'element-closest'
import 'domtokenlist/min/token-list.js'

import 'core-js/es6/set'
import 'core-js/fn/array/from'
// import 'core-js/fn/array/find'
import 'core-js/fn/array/includes'
import 'core-js/es6/promise'

import 'matchmedia-polyfill'
import 'matchmedia-polyfill/matchMedia.addListener'

import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

import MQ from 'vue-match-media/dist'
import ClipboardJS from 'clipboard'

import BackToTop from './BackToTop'
import Captcha from './Captcha'
import ContactForm from './ContactForm'
import MissingChildIntakeForm from './MissingChildIntakeForm'
import SectionNav from './SectionNav'
import TipSightingForm from './TipSightingForm'
import Modal from './Modal'
import EncodingModal from './EncodingModal'
import MissingChildIntakeFormChild from './MissingChildIntakeFormChild'
import MissingChildIntakeFormChild_fr from './MissingChildIntakeFormChild_fr'

Vue.use(MQ)

Vue.component(BackToTop.name, BackToTop)
Vue.component(Captcha.name, Captcha)
Vue.component(ContactForm.name, ContactForm)
Vue.component(MissingChildIntakeForm.name, MissingChildIntakeForm)
Vue.component(SectionNav.name, SectionNav)
Vue.component(TipSightingForm.name, TipSightingForm)
Vue.component(Modal.name, Modal)
Vue.component(EncodingModal.name, EncodingModal)
Vue.component(MissingChildIntakeFormChild.name, MissingChildIntakeFormChild)
Vue.component(MissingChildIntakeFormChild_fr.name, MissingChildIntakeFormChild_fr)

if (window.sentry_dsn) {
  Raven.config(window.sentry_dsn, {
    release: window.sentry_release
  }).addPlugin(RavenVue, Vue).install()
} else {
  console.error('window.sentry_dsn not defined - Sentry not enabled')
}

if (!window.django) {
  console.error("window.django not defined - ensure Django's jsi18n is loaded before this script")
}

// console.log('timezone:', Intl.DateTimeFormat().resolvedOptions().timeZone)

Vue.prototype.gettext = window.django.gettext
Vue.prototype.pgettext = window.django.pgettext
Vue.prototype.lang = window.django.LANGUAGE_CODE

const vueApps = document.getElementsByClassName('vue-app')

for (let i = 0; i < vueApps.length; i++) {
  const element = vueApps[i]
  const newVue = new Vue({
    el: element,
    data: {
      document: document,
      window: window
    }})
}

window.Vue = Vue


const headerMenuToggle = document.getElementById('header-menu-toggle')
// const headerSearchToggle = document.getElementById('header-search-toggle')
const headerMenu = document.getElementById('header-menu')

if (headerMenuToggle && headerMenu) {
  headerMenuToggle.addEventListener('click', function(e) {
    e.preventDefault()
    headerMenu.classList.contains('is-open')
      ? headerMenu.classList.remove('is-open')
      : headerMenu.classList.add('is-open')
    headerMenuToggle.classList.contains('is-active')
      ? headerMenuToggle.classList.remove('is-active')
      : headerMenuToggle.classList.add('is-active')
  })
}
// headerSearchToggle.addEventListener('click', function(e) {
//   if (!headerMenu.classList.contains('is-open')) headerMenu.classList.add('is-open')
//   if (!headerMenuToggle.classList.contains('is-active')) headerMenuToggle.classList.add('is-active')
//   document.getElementById('header-menu-search').focus()
// })


const collapsiblePanels = document.querySelectorAll('.js-collapsible-panel')
Array.prototype.forEach.call(collapsiblePanels, panel => {
  if (!panel.classList.contains('starts-open')) {
    panel.setAttribute('hidden', 'hidden')
  }
  panel.classList.remove('starts-open')
})

const collapsibleToggles = document.querySelectorAll('.js-collapsible-toggle')
Array.prototype.forEach.call(collapsibleToggles, btn => {
  let startsOpen = btn.classList.contains('starts-open')
  btn.setAttribute('aria-expanded', startsOpen.toString())
  btn.classList.remove('starts-open')
  let panelId = btn.getAttribute('id').replace(/^toggle-/, '')
  
  btn.addEventListener('click', function(e) {
    let expanded = btn.getAttribute('aria-expanded') === 'true' || false
    btn.setAttribute('aria-expanded', !expanded)
    
    // because older ie doesn't recognize the .hidden property:
    expanded
      ? document.getElementById(panelId).setAttribute('hidden', 'hidden')
      : document.getElementById(panelId).removeAttribute('hidden')
  })
})


const clipboard = new ClipboardJS('.js-btn-clipboard')
clipboard.on('success', function(e) {
  const targ = e.trigger
  const textSpan = targ.querySelector('.js-btn-clipboard-text')
  targ.classList.remove('btn--primary')
  targ.classList.add('btn--success')
  textSpan.innerHTML = window.django.gettext('Copied!')
  e.clearSelection()
})

const externalLinks = () => {
  if (document.getElementById('kss-node')) return
  
  const currentHostname = window.location.hostname
  for (let links = document.getElementsByTagName('a'), i = 0; i < links.length; i++) {
    const link = links[i]
    link.getAttribute('href') &&
      link.hostname !== currentHostname &&
      (link.getAttribute('href').match(/^http:\/\//) || link.getAttribute('href').match(/^https:\/\//)) &&
      !link.getAttribute('href').match(/^mailto:/) &&
      !link.getAttribute('href').match(/^tel:/) &&
      !link.classList.contains('js-no-ext-icon') &&
      (link.target = '_blank') &&
      (link.rel = 'noopener')
  }
}
window.onload = externalLinks



// WEBPACK FOOTER //
// ./js/index.js